import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { useTableContext } from '../Table.Context/index.es.js';
import { TableBodyCell } from './Table.Body.Cell/Table.Body.Cell.es.js';
import { TableBodyLoader } from './Table.Body.Loader/Table.Body.Loader.es.js';
import { TableBodyRow } from './Table.Body.Row/Table.Body.Row.es.js';

const TableBody = ({ className, children, ...rest })=>{
    const tbodyRef = useRef(null);
    const [{ loading, numLoadingRows, numLoadingColumns }, { setNumLoadingColumns }] = useTableContext();
    // Set context value based on number of child cells
    useEffect(()=>{
        if (!tbodyRef.current || Boolean(numLoadingColumns)) return;
        const dynamicLoadingColumns = tbodyRef.current.previousElementSibling?.firstChild?.childNodes.length;
        // If length is 0, fallback to default of 3
        setNumLoadingColumns(dynamicLoadingColumns ?? 3);
    }, [
        numLoadingColumns,
        setNumLoadingColumns
    ]);
    return jsx("tbody", {
        ref: tbodyRef,
        className: classNames('cb-table-body', className),
        ...rest,
        children: loading ? jsx(TableBodyLoader, {
            numRows: numLoadingRows
        }) : children
    });
};
TableBody.displayName = 'Table.Body';
TableBody.Row = TableBodyRow;
TableBody.Cell = TableBodyCell;
TableBody.Loader = TableBodyLoader;

export { TableBody };
//# sourceMappingURL=Table.Body.es.js.map
